
import setupAccount from '~/graphql/mutations/auth/setupAccount.gql';

export default {
  auth: false,
  layout: 'login',
  middleware: 'guest',
  data: () => ({
    formName: 'activate-form',
    email: '',
    token: '',
  }),
  created() {
    if (!this.$route.query.token && !this.$route.query.email) {
      this.$router.push(this.localePath({name: 'index'}));
    }

    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  },
  methods: {
    async submit(data) {
      try {
        const {data: {setupAccount: setupAccountResult}} = await this.$apollo.mutate({
          mutation: setupAccount,
          variables: {
            ...data,
            email: this.email,
            token: this.token,
          },
        });

        if (!setupAccountResult) {
          throw new Error('Failed to activate account');
        }

        this.$toast.success('Uw account is geactiveerd');
        await this.$router.push(this.localePath({name: 'auth-inloggen'}));
      } catch (err) {
        this.$formulate.handle(err, this.formName);
        this.$toast.error('Er is iets mis gegaan tijdens het activeren van uw account.');
      }
    },
  },
};
